import React from 'react';
import { auctionTrumpBubbleGlyph, bidCpTensForDisplay } from '../../game/belotArmenianCards';
import { cn } from '../../poker-ui/utils/cn';
import {
  AUCTION_DROP_TONE_CONTRA,
  AUCTION_DROP_TONE_PASS,
  AUCTION_DROP_TONE_RECONTRA,
  BELOT_FELT_LABEL_NEUTRAL,
  BelotVividSuitInlineText,
  seatAuctionBidTonePair,
} from './BelotTableSharedUi';
import { BelotSeatFloatingBadge } from './belotSeatFloatingBadge';
import { BELOT_FX_Z_ACTION_BUBBLE } from '../online/belotFxLayers';

/**
 * Пузырёк хода на базаре у места — тот же силуэт, что у капли торгов над местом.
 *
 * @param {{ action: { kind?: string, label?: string, bid?: object } | null, className?: string }} props
 */
export function BelotAuctionSeatActionBubble({ action, className }) {
  if (!action?.kind) return null;
  const kind = action.kind;

  if (kind === 'pass') {
    return (
      <div className={cn('mb-0.5 max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)]', className)} style={{ zIndex: BELOT_FX_Z_ACTION_BUBBLE }}>
        <BelotSeatFloatingBadge bubbleToneClass={AUCTION_DROP_TONE_PASS.bubble} tailToneClass={AUCTION_DROP_TONE_PASS.tail}>
          <span className="font-extrabold tracking-tight text-red-50 [text-shadow:0_1px_3px_rgba(0,0,0,0.9),0_0_16px_rgba(0,0,0,0.5)]">
            Пас
          </span>
        </BelotSeatFloatingBadge>
      </div>
    );
  }

  if (kind === 'bid' && action.bid && typeof action.bid === 'object') {
    const b = action.bid;
    const glyph = auctionTrumpBubbleGlyph(b.trump);
    const pts = bidCpTensForDisplay(b);
    const t = seatAuctionBidTonePair(b.trump);
    const label = `${glyph} ${pts} CP`;
    return (
      <div className={cn('mb-0.5 max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)]', className)} style={{ zIndex: BELOT_FX_Z_ACTION_BUBBLE }}>
        <BelotSeatFloatingBadge bubbleToneClass={cn(t.bubble, 'border-2 backdrop-blur-md')} tailToneClass={t.tail}>
          <BelotVividSuitInlineText text={label} neutralClassName={BELOT_FELT_LABEL_NEUTRAL} />
        </BelotSeatFloatingBadge>
      </div>
    );
  }

  if (kind === 'contra') {
    return (
      <div className={cn('mb-0.5 max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)]', className)} style={{ zIndex: BELOT_FX_Z_ACTION_BUBBLE }}>
        <BelotSeatFloatingBadge bubbleToneClass={AUCTION_DROP_TONE_CONTRA.bubble} tailToneClass={AUCTION_DROP_TONE_CONTRA.tail}>
          <span className="select-none text-[10px] font-black uppercase tracking-wide text-amber-50 [text-shadow:0_1px_3px_rgba(0,0,0,0.9),0_0_16px_rgba(0,0,0,0.5)]">
            Контра
          </span>
        </BelotSeatFloatingBadge>
      </div>
    );
  }

  if (kind === 'recontra') {
    return (
      <div className={cn('mb-0.5 max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)]', className)} style={{ zIndex: BELOT_FX_Z_ACTION_BUBBLE }}>
        <BelotSeatFloatingBadge bubbleToneClass={AUCTION_DROP_TONE_RECONTRA.bubble} tailToneClass={AUCTION_DROP_TONE_RECONTRA.tail}>
          <span className="select-none text-[10px] font-black uppercase tracking-wide text-amber-50 [text-shadow:0_1px_3px_rgba(0,0,0,0.88),0_0_18px_rgba(251,191,36,0.25)]">
            Реконтра
          </span>
        </BelotSeatFloatingBadge>
      </div>
    );
  }

  return null;
}
